import { computed, makeObservable } from 'mobx';
import { KvBnrModel } from './kv.bnr.model';

export interface ISavedBerichtData {
	fileName: string;
	fullPath: string;
	reportPath: string;
	created: string;
}

export class SavedBerichtModel extends KvBnrModel {
	constructor(opts: any) {
		super(opts);
		makeObservable(this);
		this.group = 'saved_berichte';
		if (opts.valueString) {
			const data: ISavedBerichtData = JSON.parse(opts.valueString);
			this.fileName = data.fileName;
			this.fullPath = data.fullPath;
			this.reportPath = data.reportPath;
			this.created = new Date(data.created);
		}
	}

	fileName: string = '';
	fullPath: string = '';
	created: Date = new Date();
	reportPath: string = '';

	@computed
	get reportPathWithoutParms(): string {
		const idx = this.reportPath.indexOf('?');
		let path = idx >= 0 ? this.reportPath.substring(0, idx) : this.reportPath;

		if (path.endsWith('/')) {
			path = path.slice(0, -1);
		}

		return path;
	}

	@computed
	get createdFormatted(): string {
		return this.created.toLocaleDateString('de-DE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			// hour: '2-digit',
			// minute: '2-digit',
		});
	}
}
